import {h} from 'preact';

const paidServicesDocuments = [
    {
        href: 'https://disk.yandex.ru/i/8YyXi6GQXM9xkA',
        label: 'Положение о порядке расчета стоимости и предоставления специальных условий оплаты образовательных услуг по дополнительным общеобразовательным программам для взрослых ООО «ИТК»'
    },
    {
        href: '/assets/documents/stoimost/polozhenie-o-predostavlenii-platnyh-obrazovatelnyh-uslug-itk.pdf',
        label: 'Положение о предоставлении платных образовательных услуг ООО «ИТК»'
    },
    {
        href: 'https://disk.yandex.ru/i/5Eq0-glk5kcSCw',
        label: 'Положение об оказании платных услуг ООО «ИТК»'
    },
    {
        href: 'https://disk.yandex.ru/i/eCU6hGV2qoMzHg',
        label: 'Положение о неисключительной лицензии ИТК Академия'
    },
    {
        href: 'https://disk.yandex.ru/i/STIilnlWuwwHzQ',
        label: 'Регламент изменения и расторжения договоров ООО «ИТК»'
    },
    {
        href: 'https://disk.yandex.ru/i/xGGGMuxqdcG_hg',
        label: 'Регламент обработки заявок на техническую поддержку Лицензиата в рамках использования ПО «ИТК Академия» (по тарифу «ИТК Академия Премиум»)'
    }
];

const PaidServicesDocuments = () => (
    <ul className={'pdfLinks'}>
        {paidServicesDocuments.map(({href, label}) => (
            <li key={href}>
                <a target="_blank" href={href} rel="noreferrer">
                    {label}
                </a>
            </li>
        ))}
    </ul>
);

export default PaidServicesDocuments;
